import {sexsorteventlayer} from '@/lib/api/index.js'

const grade = {
  state: {
    tableTypeW: 52,
    gradeList: [],
    position: 0,
    setGames: {},
    sexsorteventlayerList:[],
    searchsexsorteventlayerList:[]
  },
  getters: {

  },
  mutations: {
    sexsorteventlayerList(state, data)
    {
      if(data===false)
      {
        state.sexsorteventlayerList = []
        state.searchsexsorteventlayerList = []
      }else{
        state.sexsorteventlayerList = data
        state.searchsexsorteventlayerList = data
      }
    },
    upGradeList (state, data) {
      state.gradeList = data
    },
    SAVE_POSITION (state, data) {
      state.position = data
    },
    getGames (state, data) {
      state.setGames = data
    }

  },
  actions: {
    getGradeList ({commit}, data) {
      console.log(data, 555)
      commit('upGradeList', data)
    },
    sexsorteventlayerF({commit}, data)
    {
      sexsorteventlayer(data).then(res => {
          if(res.data.code == 0){
            if(res.data.data.length)
            {
              commit('sexsorteventlayerList', res.data.data)
              
            }else{
              commit('sexsorteventlayerList', false)
            }
          }else if(res.data.code == -2){
              this.$Message.error("获取失败");
          }else if(res.data.code==10)
          {
              this.$Message.info("登录token过期请重新登录");
              this.$store.dispatch('loginOut');
          }else{
              this.$Message.error(res.data.msg);
          }
      },err =>{
          this.$Message.error("网络连接失败");
      });
     }
   
  }
}

export default grade



// WEBPACK FOOTER //
// ./src/store/modules/grade.js